import React from "react";
import { cn } from "./cn";
import Breadcrumbs from "./Breadcrumbs";

/** Unified page heading: optional breadcrumbs, title, subtitle, and right-aligned actions. */
export default function PageHeader({ title, subtitle, breadcrumbs, actions, className }) {
  return (
    <div className={cn("mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between", className)}>
      <div className="min-w-0">
        {breadcrumbs?.length ? <Breadcrumbs items={breadcrumbs} className="mb-2" /> : null}
        <h1 className="truncate text-xl font-semibold tracking-tight text-ink">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
